import { Component } from '@angular/core';
import { PrintableReportComponentR1 } from '../../../../widget-library/widgets/printable-report-r1/printable-report-r1.component';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';
import { StorageSessionService } from '../../../../../core/storage/services/storage.session.service';
import { AnalyticsCoreURLService } from '../../../../analytics-core/services/analytics-core.url.service';
import { ModalService } from '../../../../shared/directives/modal/modal.service';
import { Router } from '@angular/router';
import { AnalyticsMixpanelService } from '../../../../analytics/services/analytics.mixpanel.service';
import { EmitterService } from '../../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../../analytics/constants/analytics.constants';
@Component({
	selector: 'app-printable-report-component-r6',
	// templateUrl: './printable-report-component-r6.component.html',
	templateUrl: '../../../../widget-library/widgets/printable-report-r1/printable-report-r1.component.html',
	styleUrls: ['./printable-report-component-r6.component.css']
})
export class PrintableReportComponentR6Component extends PrintableReportComponentR1 {
	constructor(
		protected modalService: ModalService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected storageSessionService: StorageSessionService,
		protected analyticsCoreURLService: AnalyticsCoreURLService,
		protected router: Router,
		protected analyticsMixpanelService: AnalyticsMixpanelService
	) {
		super(
			modalService,
			analyticsDataModel,
			storageSessionService,
			analyticsCoreURLService,
			router,
			analyticsMixpanelService
		);
		EmitterService.get(EVENT_EMITTERS.HAS_PRODUCT_PRINTABLE_ACCESS).subscribe((response: any) => {
			this.hasPrintableAccess = response.permissions;
			this.accessibleCampaigns = response.activeCampaigns;
		});
	}
}
